import { EmployerAgreementsGenerateService_generateEmployerAgreementsServicePostFrame } from '@festina/life-general-types/life/hooks/EmployerAgreementsGenerateService_generateEmployerAgreementsServicePostFrame'

/** This hook should be used in DK layer to fetch frame for create agreement command.
 * It returns DontUseVFrame for employerAgreementId that is generated in the backend when applying the create command. */
export const useFetchEmployerAgreementGenerateIdCreateFrame =
  EmployerAgreementsGenerateService_generateEmployerAgreementsServicePostFrame.useSuspenseQuery
